import type { ComponentProps } from 'react';

export const ArrowIcon = (props:ComponentProps<'svg'>) => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M45.4445 23C47.8675 27.5314 51.1176 31.5689 55.0267 34.904L61 40M61 40L55.0267 45.096C51.1176 48.4311 47.8675 52.4686 45.4445 57M61 40L19 40"
      stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="bevel" />
  </svg>

)